import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  addRemoveFavoriteEtab,
  addRemoveFavoriteProposal,
  getFavoriteEtab,
  getFavoriteProposal
} from '@utils/favorites';
import { FavoriteModeType } from 'types';
import { FavoriteOutlined } from '@mui/icons-material';
import { useSession } from '@hooks';

type ButtonAddToFavoritesProps = {
  mode: FavoriteModeType;
  etabId?: number;
  proposalKey?: string;
};

const languagesVarsCodes = [
  "LANG_neobooking_delete_from_favorites", //Supprimer des favoris
  "LANG_neobooking_add_to_favorites", //Ajouter aux favoris
]

const ButtonAddToFavorites: React.FC<ButtonAddToFavoritesProps> = ({ mode, etabId, proposalKey }) => {

  /* Hooks */
  const { sessionId, setFavoriteProposals, favoriteProposals, favoriteEtabs, setFavoriteEtabs, getLanguageVarValue } = useSession();

  /* State */
  const [isFavorite, setIsFavorite] = useState((mode === "proposal" && proposalKey) ? getFavoriteProposal(sessionId!!, proposalKey) : getFavoriteEtab(sessionId!!, etabId!!) !== null ? true : false);

  useEffect(() => {
    if (mode === "proposal" && proposalKey) {
      setIsFavorite(getFavoriteProposal(sessionId!!, proposalKey) !== null ? true : false);
    }
    if (mode === "etab" && etabId) {
      setIsFavorite(getFavoriteEtab(sessionId!!, etabId) !== null ? true : false);
    }
  }, [favoriteProposals, favoriteEtabs])

  const handleAddToFavorites = () => {
    if (mode === "proposal" && proposalKey) {
      addRemoveFavoriteProposal(sessionId!!, proposalKey, (keys) => {
        setIsFavorite(!isFavorite);
        setFavoriteProposals(keys)
      });
    }
    if (mode === "etab" && etabId) {
      addRemoveFavoriteEtab(sessionId!!, etabId, (keys) => {
        setIsFavorite(!isFavorite);
        setFavoriteEtabs(keys)
      });
    }
  }

  return (
    <button
      title={isFavorite ? getLanguageVarValue("LANG_neobooking_delete_from_favorites") : getLanguageVarValue("LANG_neobooking_add_to_favorites")}
      className={classNames(isFavorite ? "tw-text-red-500 hover:tw-text-red-400" : "tw-text-gray-400 hover:tw-text-red-500", "tw-duration-200 tw-transition-all tw-ease-in-out")}
      type={"button"}
      onClick={handleAddToFavorites}>
      <FavoriteOutlined />
    </button>
  )
};

ButtonAddToFavorites.propTypes = {
  //
};

export default ButtonAddToFavorites


